<template>
    <div>
      <list
        row-key="RecordId"
        ref="list"
        unit="会员信息"
        :expand-all-row="true"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="api.list"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
          <el-form-item label="会员姓名">
            <el-input v-model="params.PersonName" placeholder="请输入会员姓名" clearable />
          </el-form-item>
          <el-form-item label="商品名称">
            <el-input v-model="params.GoodsName" placeholder="请输入商品名称" clearable />
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input v-model="params.OrderNo" placeholder="请输入订单编号" clearable />
          </el-form-item>
          <el-form-item label="评论内容">
            <el-input v-model="params.CommentNotes" placeholder="请输入评论内容" clearable />
          </el-form-item>
                  
          <el-form-item label="评论日期">
            <el-date-picker
              size="mini"
              v-model.trim="params.CommentStarttime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
            <span style="margin:0 10px;">-</span>
            <el-date-picker
              size="mini"
              v-model.trim="params.CommentEndtime"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              style="width: 180px"
            ></el-date-picker>
          </el-form-item>

        </template>
        <template slot="table">
         
          <el-table-column prop="PersonName" label="会员姓名" min-width="60px" />
          <el-table-column prop="GoodsName" label="商品名称" min-width="180px"/>
          <el-table-column prop="OrderNo" label="订单编号" min-width="120px"/>
         
          <el-table-column prop="CommentNotes" label="评论内容" min-width="150px"/>
          <el-table-column prop="CommentTime" label="评论时间" min-width="150px"/>
          <el-table-column prop="StoreName" label="所属门店" v-if="$permission.isStore()==false"/>
          <slot name="column"></slot>
         
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/person/personcomment").default,
        params: {
          PersonName: "",
          GoodsName: "",
          OrderNo: "",
          CommentNotes: "",
          CommentStarttime: null,
          CommentEndtime: null,
          
        },
      };
    },
   mounted() {
    
    },
    methods: {
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
  </script>